import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20peach%20coral%20abstract%20gradient%20background%2C%20soft%20flowing%20shapes%20in%20cream%20and%20coral%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20modern%20minimalist%20digital%20art%2C%20elegant%20composition%20with%20warm%20lighting&width=1800&height=800&seq=cta-bg-peach&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/60 to-primary-800/40"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好探索精彩世界了吗？
        </h2>
        <p className="text-background-200 mb-8 leading-relaxed">
          数百万用户已经在8x8x水蜜桃找到了心仪的内容。加入我们，开启你的专属数字体验之旅！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/resources"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-full font-medium transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/25"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即体验
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-md text-background-100 rounded-full font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            <i className="ri-customer-service-line mr-2"></i>
            联系客服
          </Link>
        </div>
      </div>
    </section>
  );
}